(function () {
  const wrapper = document.querySelector("#cart-drawer");
  const button = document.querySelector(".header-cart");

  if (!wrapper || !button) return;

  const open = () => {
    wrapper.classList.add("cart-drawer-open");
    document.body.style.overflow = "hidden";
  };

  const close = () => {
    wrapper.classList.remove("cart-drawer-open");
    document.body.style.overflow = "";
  };

  button.addEventListener("click", open);

  // Delegacja z wrappera — wrapper nigdy nie jest podmieniany przy refreshu
  // sekcji (cart.js robi liveEl.innerHTML = newEl.innerHTML), więc listener
  // przeżyje każde odświeżenie. Bezpośrednie addEventListener na overlayu/X
  // gubiłoby się po pierwszej zmianie ilości w otwartym drawerze.
  wrapper.addEventListener("click", (e) => {
    if (e.target.closest("[data-cart-close]")) {
      close();
    }
  });

  // cart.js dispatchuje to po udanym /cart/add.js — odpalamy drawer zamiast
  // pełnego redirectu na /cart.
  document.addEventListener("cart:added", open);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && wrapper.classList.contains("cart-drawer-open")) {
      close();
    }
  });
})();
